module.exports = __webpack_public_path__ + "img/new-releases.f8cf3b3d.jpg";